import { inject } from 'vue';

export interface GrantedContext {
	isGranted: (rights: string | string[]) => boolean;
	routeGranted: (routeName: string) => boolean;
}

/**
 * Teste un ou plusieurs droits (ET logique).
 *
 * Usage : `const isGranted = useIsGranted(); isGranted(Right.BO_LIVE_MAP)`.
 */
export function useIsGranted(): (rights: string | string[]) => boolean {
	const granted = inject<GrantedContext>('granted');
	return (rights) => granted?.isGranted(rights) ?? false;
}
